import http from '@/plugins/http'
import axios from 'axios'
import i18n from '@/plugins/vuei18n'
import Cookies from 'js-cookie'
import {accessControl} from "../router/rules"
/* global localStorage */

const setUpAuthorizationStorage = payload => {
  localStorage.setItem('access_token', payload.token)
  localStorage.setItem('token_expiration', payload.tokenExpiration)
  if (payload.refreshToken) {
    localStorage.setItem('refresh_token', payload.refreshToken)
  }
}

export default {
  authRequest({
    commit
  }, payload) {
    let keepLogged = payload.keepLogged
    delete payload.keepLogged
    delete http.defaults.headers.common.Authorization
    return new Promise((resolve, reject) => {
      commit('authRequest')
      http.post('oauth2/token', payload).then(({
        data
      }) => {
        if(data.code == 'sended'){
          resolve(data)
        }

        let tokenExpiration = Math.floor(Date.now() / 1000) + data.expires_in - 5 // -5s just in case
        let storageData = {
          token: data.access_token,
          tokenExpiration
        }
        if (keepLogged) {
          storageData.refreshToken = data.refresh_token
        }
        setUpAuthorizationStorage(storageData)
        http.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access_token')
        commit('authSuccess', storageData)
        resolve(data)
      }).catch(err => {
        commit('authError')
        localStorage.removeItem('access_token')
        reject(err)
      })
    })
  },
  authPassword(context, payload) {
    let data = {
      grant_type: 'password',
      username: payload.username,
      password: payload.password,
      client_id: process.env.VUE_APP_API_CLIENT_ID,
      client_secret: process.env.VUE_APP_API_CLIENT_SECRET,
      keepLogged: payload.keepLogged
    }

    if(payload.sms_code){
      data['sms_code'] = payload.sms_code
    }

    return context.dispatch('authRequest', data)
  },
  authRefresh(context) {
    return context.dispatch('authRequest', {
      grant_type: 'refresh_token',
      refresh_token: context.state.refreshToken,
      client_id: process.env.VUE_APP_API_CLIENT_ID,
      client_secret: process.env.VUE_APP_API_CLIENT_SECRET,
      keepLogged: true
    })
  },
  authLogout({
    commit
  }) {
    localStorage.removeItem('access_token')
    localStorage.removeItem('token_expiration')
    localStorage.removeItem('refresh_token')
    localStorage.removeItem('user')
    delete http.defaults.headers.common['Authorization']
    commit('authLogout')
  },
  whoami() {
    return http.get('who-am-i').then(data=>{
      localStorage.setItem('user', btoa(unescape(encodeURIComponent(JSON.stringify(data.data)))))
    })
  },
  load({
    dispatch
  }) {
    dispatch('loadTeams')
    dispatch('loadFieldTypes')
    dispatch('loadUsers')
  },
  loadTeams({
    commit
  }) {
    return new Promise((resolve, reject) => {
      http.get('teams')
        .then(response => {
          commit('setTeams', response.data)
          resolve(response.status)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  loadArchiveFilters({
    commit
  }) {
    return new Promise((resolve, reject) => {
      http.get('archives/filters')
        .then(response => {
          commit('setArchiveFilters', response.data)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  createArchiveFilter({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      http.post('archives/create-filter', payload)
        .then(response => {
          commit('appendArchiveFilter', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateArchiveFilter({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      http.put('archive/filter/' + payload.id, payload.data).then(data => {
        commit("updateArchiveFilter", data.data)
        resolve(data)
      }).catch((e) => {
        reject(e)
      })
    })
  },
  deleteArchiveFilter({
    commit
  }, id) {
    return new Promise((resolve, reject) => {
      http.delete('archives/filter/' + id).then(data => {
        commit('deleteArchiveFilter', id)
        resolve(data)
      }).catch((e) => {
        reject(e)
      })
    })
  },
  createTeam({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      http.post('team', payload)
        .then(({
          data
        }) => {
          commit('appendTeam', data)
          resolve()
        }).catch(error => {
          reject(error)
        })
    })
  },
  loadUsers({
    commit
  }) {
    return new Promise((resolve, reject) => {
      http.get('users')
        .then(response => {
          commit('setUsers', response.data)
          resolve(response.status)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  createUser(context, payload) {
    return new Promise((resolve, reject) => {
      http.post('user', payload)
        .then(response => {
          resolve(response.status)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateUser(context, payload) {
    return new Promise((resolve, reject) => {
      let idUser = payload.idUser
      delete payload.idUser
      http.patch('user/' + idUser, payload)
        .then(response => {
          resolve(response.status)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  loadFieldTypes({
    commit
  }) {
    http.get('field/types')
      .then(({
        data
      }) => {
        commit('setFieldTypes', data)
      })
  },
  updateTeam(context, payload) {
    http.patch('team/' + payload.id, payload)
      .then(({
        data
      }) => {
        context.commit('updateTeam', data)
      })
  },
  removeTeam(context, payload) {
    return new Promise((resolve, reject) => {
      http.delete('team/' + payload.id)
        .then(() => {
          context.commit('removeTeam', payload.index)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  createSchema({
    state
  }) {
    return http.post('schema', state.schemaBuilder)
  },
  updateSchema({
    state
  }) {
    return http.put('schema/' + state.schemaBuilder.id, state.schemaBuilder)
  },
  setSchemaTeams(context, payload) {
    return http.patch('schema/' + payload.id + '/teams', payload.teams)
  },
  deleteSchema(context, id) {
    return http.delete('schema/' + id)
  },
  setSchemaStatus(context, payload) {
    return http.patch('schema/' + payload.id + '/status/' + payload.status)
  },
  loadForms(context, payload) {
    return new Promise((resolve, reject) => {
      const {
        page,
        rowsPerPage
      } = payload.pagination
      let lang = context.state.lang
      let byUser = payload.by_user ? "/by-user" : ""
      axios.all([
        http.get('schema/' + payload.schema_id + `/${lang}`),
        http.get('form/' + payload.schema_id + byUser, {
          params: {
            page,
            pageSize: rowsPerPage,
            state: payload.state,
            ...payload.condition
          }
        }),
        http.get('form/' + payload.schema_id + '/count' + byUser, {
          params: {
            state: payload.state,
            ...payload.condition
          }
        })
      ])
        .then(axios.spread((schema, forms, count) => {
          context.commit('setUpForms', {
            schema: schema.data,
            forms: forms.data,
            count: count.data
          })
          resolve()
        }))
        .catch(error => {
          reject(error)
        })
    })
  },
  loadSingleForm(context, payload) {
    return new Promise((resolve, reject) => {
      let lang = Cookies.get('lang')
      axios.all([
        http.get('schema/' + payload.schema_id + `/${lang}`),
        http.get('form/' + payload.schema_id + "/" + payload.form_id),
      ])
        .then(axios.spread((schema, form) => {
          context.commit('setUpForms', {
            schema: schema.data,
            forms: [form.data],
            count: 1
          })
          resolve()
        }))
        .catch(error => {
          reject(error)
        })
    })
  },

  loadCycleForms(context, payload) {
    return new Promise((resolve, reject) => {
      axios.all([
        http.get('schema/' + payload.schema_id),
        http.get('cycle/' + payload.cycle_id + '/forms/' + payload.schema_id),
      ])
        .then(axios.spread((schema, forms) => {
          context.commit('setUpForms', {
            schema: schema.data,
            forms: forms.data,
            count: forms.data.length
          })
          resolve()
        }))
        .catch(error => {
          reject(error)
        })
    })
  },
  confirmForm(context, payload) {
    return new Promise((resolve, reject) => {
      http.post('form/confirm', payload)
        .then(({
          data
        }) => {
          context.commit('confirmRecord', data)
          resolve()
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  deleteForm(context, payload) {
    return new Promise((resolve, reject) => {
      http.delete('form', {
        data: payload
      })
        .then(() => {
          context.commit('deleteFormRecord', payload.form_id)
          resolve()
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  updateStateForm(context,payload){
    return new Promise((resolve, reject) => {
      http.patch('form/' + payload.schema_id + '/' + payload.form_id + '/state', {
        state: payload.state
      })
        .then(() => {
          context.commit('updateStateForm', payload)
          resolve()
        })
        .catch((e) => {
          reject(e)
        })
    })
  },
  updateFieldValue(context, {idForm, idSchema, schemaField, value}) {
    http.put('form/' + idSchema + "/" + idForm, {
      "id": idForm,
      "results": [{
        "order": schemaField.order,
        "value": value
      }]
    }).then(() => {
      context.commit("updateFieldValue", {idForm, schemaField, value})
    })
  },
  loadRelatedSchemas(context){
    http.get('related/schema').then( data => {
      context.commit("setRelatedSchemas", data.data)
    })
      .catch(() => context.commit("setSnack", {
        message: i18n.t("related.errors.download_schema"),
      }))
  },
  loadAgencies(context){
    if(!accessControl.isAllowed("viewAgency")){
      return
    }

    return http.get('agencies').then( data => {
      context.commit("setAgencies", data.data)
    }).catch(() => context.commit("setSnack", {
      message: i18n.t("error"),
    }))
  },
  loadRelatedGroupTypes(context){
    http.get("related/group/type")
      .then( data => context.commit('setRelatedGroupTypes', data.data))
      .catch(() => context.commit("setSnack", {
        message: i18n.t("related.errors.download_group_type"),
      }))
  },
  loadRelatedGroup(context){
    http.get("related/group")
      .then(data => context.commit('setRelatedGroup', data.data))
      .catch(() => context.commit("setSnack", {
        message: i18n.t("related.errors.download_group"),
      }))
  },
  loadValuesType({commit, state}, { idType } ){
    if (state.relatedValuesType.find(el => el.idType == idType) == undefined) {
      http.get("related/group/type/" + idType + "/values")
        .then(data => commit("addRelatedValuesType", {idType, values: data.data}))
        .catch(() => commit("setSnack", {
          message: i18n.t("related.errors.download_values"),
        }))
    }
  },
  loadRelatedValuesByCode(context,payload){
    return http.get("related/group/type/" + payload.group_type_id + "/values/code/" + payload.code).then(data => {
      context.commit('addRelatedValues', {'relatedValues': data.data, ...payload})
      return data.data
    }).catch(() => {
      context.commit('addRelatedValues', {'relatedValues': [], ...payload})
      context.commit("setSnack", {
        message: i18n.t("related.errors.download_values"),
      })
    })
  },
  loadStorageTypes(context){
    context.commit('setStorageTypes', [])
    return http.get("storage/types").then(data =>{
      context.commit('setStorageTypes', data.data)
    }).catch(() => {
      context.commit("setSnack", {
        message: i18n.t("Problem z pobraniem typów magazynu"),
      })
    })
  },
  initFormViewOptions(context, id = null) {
    context.commit('setFormViewOptions', {columnWidth: 150, hiddenFields: []})
    let formStyles = localStorage.getItem('form_options')
    if (formStyles == null) {
      return
    }

    formStyles = JSON.parse(formStyles)

    if (formStyles[id]) {
      return context.commit('setFormViewOptions', {
        ...context.state.formViewOptions,
        ...formStyles[id],
      })
    }

    if (formStyles['global'] != null) {
      return context.commit('setFormViewOptions', formStyles['global'])
    }
  },
  updateFormViewOptions(context, payload) {
    if (!payload.data || payload.id == null || !Array.isArray(payload.data.hiddenFields)) {
      return
    }
    let settings = JSON.parse(localStorage.getItem('form_options'))

    if (settings == null) {
      settings = {}
    }

    let formId = payload.id
    if (settings[formId] == null) {
      settings[formId] = {}
    }

    settings[formId] = payload.data
    localStorage.setItem('form_options', JSON.stringify(settings))
    return context.commit('setFormViewOptions', settings[formId])
  }
}
